import {Img} from '../../models/editor/img'
import {Pos} from '../../models/common/pos'

export const createPositionFromOffset = (img: Img, offset: Pos): Pos => {
  return {
    x: img.position.x + offset.x,
    y: img.position.y + offset.y,
  }
}
